<div>
  <div class="content-card">
    @if (isEducationHistoryAlertVisible) {
      <alert message="WF-EducationHistoryAlert" alertType="info"></alert>
    }

    <app-education-history-list 
      [workerId]="workerId"
      [workerFormContext]="true"
      [isLoggedUserProfile]="isLoggedUserProfile" 
      (educationHistoryChange)="onEducationHistoryChanged($event)">
    </app-education-history-list>

    <br />

    <div class="header-wrapper"></div>

    <div fxLayout="row" fxLayoutAlign="space-between center" class="mt-20">
      <button id="education-history-step-back-button" mat-raised-button color="accent" matStepperPrevious>
        <mat-icon>arrow_back</mat-icon>
        {{ 'Back' | translate }}
      </button>
      <button id="education-history-step-next-button" [disabled]="isNextButtonDisabled" mat-raised-button color="primary" (click)="submitAndContinue()">
        {{ 'Next' | translate }}
      </button>
    </div>
  </div>
</div>
